import DailyMenuOffer from "@/model/DailyMenuOffer";
import { StructuredMenuOfferResponse } from '@/types/service-response'

export default class MenuOffer {
  private constructor (
    readonly menuList: DailyMenuOffer[],

  ) {}

  static createEmpty (): MenuOffer {
    return new MenuOffer([])
  }

  static createFromResponse (responseData: StructuredMenuOfferResponse): MenuOffer {
    return new MenuOffer(
        responseData.map( (item:any):DailyMenuOffer => DailyMenuOffer.createFromResponse(item))
    )
  }
}
